"use client";

import React, { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  number: "5.05M+",
  label: "Total Views"
}, {
  number: "12+",
  label: "Tracks Released"
}, {
  number: "2024",
  label: "Latest Album"
}];
function StatCard({
  stat,
  index
}: {
  stat: typeof stats[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    rootMargin: "0px 0px -50px 0px"
  });
  const [count, setCount] = useState(0);
  const isCountable = index < 2;
  useEffect(() => {
    if (isVisible && isCountable) {
      let startTimestamp: number | null = null;
      const duration = 2000;
      const target = parseFloat(stat.number.replace(/[^0-9.]/g, ""));
      const step = (timestamp: number) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        const easedProgress = 1 - Math.pow(1 - progress, 4);
        setCount(easedProgress * target);
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }, [isVisible, isCountable, stat.number]);
  const formatNumber = (val: number) => {
    if (stat.number.includes(".")) {
      return val.toFixed(2);
    }
    return Math.floor(val).toString();
  };
  const suffix = stat.number.replace(/[0-9.]/g, "");
  const isLatestAlbum = index === 2;
  const animationClasses = isLatestAlbum ? `duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}` : `duration-500 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`;
  return <Card ref={ref} data-index={index} className={`flex flex-col items-center justify-center p-10 text-center border border-white/10 bg-white/5 backdrop-blur-lg rounded-lg shadow-sm hover:shadow-[0_0_30px_-5px_rgba(255,106,0,0.4)] hover:border-primary transition-all transform ${animationClasses}`} style={{
    transitionDelay: `${index * 200}ms`
  }}>
      <span className="font-serif text-[3rem] font-bold text-white leading-none tracking-tighter">
        {isCountable ? <>
            {formatNumber(isVisible ? count : 0)}
            {suffix}
          </> : stat.number}
      </span>
      <div className="w-12 h-[2px] bg-primary mt-3 mb-4 rounded-full shadow-[0_0_10px_rgba(255,106,0,0.5)]" />
      <span className="font-sans text-sm text-[#E5E5E5] font-semibold uppercase tracking-widest">
        {stat.label}
      </span>
    </Card>;
}
export default function OurImpactInNumbers() {
  return <section data-section-id="143746" id="ministry-impact" className="bg-background pt-12 pb-6 md:pt-16 md:pb-8 overflow-hidden dark text-foreground">
      <div className="container mx-auto px-10 md:px-20 max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {stats.map((stat, i) => <StatCard key={i} stat={stat} index={i} />)}
        </div>
      </div>
    </section>;
}